import React, { useEffect, useState } from 'react';
import '../../styles/landing.css';
import PublicNav from '../../components/public/PublicNav';
import PublicFooter from '../../components/public/PublicFooter';
import PricingSection from '../../components/public/PricingSection';
import FaqSection from '../../components/public/FaqSection';
import SignupModal from '../../components/public/SignupModal';
import { PRICING_TIERS } from '../../data/pricingTiers';

const COMPARE_ROWS = [
  { label: 'Workspaces', starter: '1', growth: '1', scale: 'Up to 5', enterprise: 'Unlimited' },
  { label: 'Seats', starter: '5', growth: '50', scale: '150', enterprise: 'Unlimited' },
  { label: 'Credits / month', starter: '10,000', growth: '100,000', scale: '250,000', enterprise: 'Custom' },
  { label: 'Skill registry & governance', starter: true, growth: true, scale: true, enterprise: true },
  { label: 'Approvals & audit trail', starter: true, growth: true, scale: true, enterprise: true },
  { label: 'Native integrations', starter: 'Core', growth: 'Full', scale: 'Full', enterprise: 'Full + custom' },
  { label: 'Department suites', starter: false, growth: false, scale: true, enterprise: true },
  { label: 'Support', starter: 'Email', growth: 'Priority', scale: 'Slack', enterprise: '24×7 + TAM' },
  { label: 'SSO / SAML', starter: false, growth: false, scale: false, enterprise: 'Roadmap' },
];

function Cell({ value }) {
  if (value === true) return <span className="lp-compare__yes" aria-label="Included">✓</span>;
  if (value === false) return <span className="lp-compare__no" aria-label="Not included">—</span>;
  return <span className="lp-compare__text">{value}</span>;
}

export default function Pricing() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [ready, setReady] = useState(false);
  const enterpriseTier = PRICING_TIERS.find((t) => t.key === 'enterprise');

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className={`lp-root ${ready ? 'lp-root--ready' : ''}`}>
      <PublicNav />

      <section className="lp-pricing-hero">
        <div className="lp-pricing-hero__glow" aria-hidden="true" />
        <div className="lp-pricing-hero__grid" aria-hidden="true" />
        <div className="lp-pricing-hero__inner">
          <p className="lp-hero__brand">Enterprise Claude Skills</p>
          <h1>Straightforward plans for governed AI work</h1>
          <p>
            Full skill registry, routing, approvals, and audit on every tier.
            Scale credits and seats as your rollout grows.
          </p>
        </div>
      </section>

      <PricingSection showHeading={false} />

      <section className="lp-compare" id="compare">
        <div className="lp-section__head lp-section__head--left">
          <p className="lp-eyebrow">Compare</p>
          <h2>What’s included in each plan</h2>
          <p className="lp-section__sub">
            Same control plane everywhere — difference is capacity, suites, and support.
          </p>
        </div>
        <div className="lp-compare__wrap">
          <table className="lp-compare__table">
            <thead>
              <tr>
                <th scope="col" className="lp-compare__feature-head">Capability</th>
                <th scope="col">Starter</th>
                <th scope="col">Growth</th>
                <th scope="col">Scale</th>
                <th scope="col">Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE_ROWS.map((row) => (
                <tr key={row.label}>
                  <th scope="row" className="lp-compare__label">{row.label}</th>
                  <td><Cell value={row.starter} /></td>
                  <td><Cell value={row.growth} /></td>
                  <td><Cell value={row.scale} /></td>
                  <td><Cell value={row.enterprise} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="lp-enterprise" id="contact">
        <div className="lp-enterprise__inner">
          <div>
            <p className="lp-eyebrow lp-eyebrow--light">Enterprise</p>
            <h2>Need custom governance, credits, or a guided pilot?</h2>
            <p>
              We’ll map suites to your departments, wire Slack and Plane, and size credits
              for your rollout — before any long contract.
            </p>
          </div>
          <button
            type="button"
            className="lp-btn lp-btn--primary lp-btn--lg"
            onClick={() => setShowContactModal(true)}
          >
            Talk to sales
          </button>
        </div>
      </section>

      <FaqSection />

      <PublicFooter />

      {showContactModal && (
        <SignupModal
          plan={enterpriseTier}
          billingCycle={false}
          onClose={() => setShowContactModal(false)}
        />
      )}
    </div>
  );
}
